<p-dialog [(visible)]="displayDialog" [modal]="true" [draggable]="false" (onHide)="closeDialog()">
    <ng-template pTemplate="header">
        <h4><i class="pi pi-lock"></i> Cambio de contraseña</h4>
    </ng-template>
    <ng-template pTemplate="content">
        <form [formGroup]="passwordForm" class="m-2">
            <div class="field mb-5">
                <span class="p-float-label">
                    <p-password id="password" formControlName="password" [feedback]="false"
                        maxlength="20" minlength="6" class="w-full" inputStyleClass="w-full p-inputtext-lg" styleClass="w-full"
                        [class.ng-invalid]="this.passwordForm.get('password')?.invalid && this.passwordForm.get('password')?.touched"></p-password>
                    <label htmlFor="password">Nueva contraseña</label>
                </span>
            </div>
            <div class="field mb-5">
                <span class="p-float-label">
                    <p-password id="password-confirm" formControlName="passwordConfirm" [feedback]="false"
                        maxlength="20" minlength="6" class="w-full" inputStyleClass="w-full p-inputtext-lg" styleClass="w-full"
                        [class.ng-invalid]="this.passwordForm.get('passwordConfirm')?.invalid && this.passwordForm.get('passwordConfirm')?.touched"></p-password>
                    <label htmlFor="password-confirm">Confirmar contraseña</label>
                </span>
            </div>
        </form>
        <p *ngIf="passwordForm.errors?.['passwordNotMatching'] && (passwordForm.touched || passwordForm.dirty)"
            class="text-xs text-red-600">Las contraseñas no coinciden</p>
        <p *ngIf="(passwordForm.get('password')?.errors?.['minlength'] || passwordForm.get('passwordConfirm')?.errors?.['minlength'])
            && (passwordForm.touched || passwordForm.dirty)" class="text-xs text-red-600">
            La contraseña debe tener mínimo 6 caracteres
        </p>
    </ng-template>
    <ng-template pTemplate="footer">
        <p-button label="Cancelar" icon="pi pi-times" class="grey" (onClick)="closeDialog()" ariaLabel="Cancelar"></p-button>
        <p-button label="Aceptar" icon="pi pi-check" (onClick)="changePassword()" [disabled]="this.passwordForm.invalid" ariaLabel="Aceptar"></p-button>
    </ng-template>
</p-dialog>